import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { ActionCreator } from '@ngrx/store';
import { map, merge, Observable, switchMap, take, throwError } from 'rxjs';
import { FailureAction, SuccessAction } from '@store/models';
import { ActionsGroup } from '@store/utils';

@Injectable({ providedIn: 'root' })
export class ActionResponseHandlerService {
  constructor(private readonly actions$: Actions) {}

  handle<T>(actions: ActionsGroup): Observable<T> {
    const successActionResponse: Observable<T> = this.handlerSuccessAction<T>(actions.success);
    const failureActionResponse: Observable<T> = this.handlerFailureAction(actions.failure);
    return merge(successActionResponse, failureActionResponse).pipe(take(1));
  }

  private handlerSuccessAction<T>(successAction: ActionCreator): Observable<T> {
    return this.getAction<SuccessAction<T>>(successAction).pipe(map((action: SuccessAction<T>) => action.response));
  }

  private handlerFailureAction(failureAction: ActionCreator) {
    return this.getAction<FailureAction>(failureAction).pipe(
      switchMap((action: FailureAction) => throwError(() => action.error))
    );
  }

  private getAction<T>(action: ActionCreator): Observable<T> {
    return this.actions$.pipe(ofType(action));
  }
}
